module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-text-window-b1ed57af.svg";